// extracted by css-extract-rspack-plugin
export default {"root":"Abmoek","card":"ajeALB","logoRow":"AHO4kP","logo":"gJ1ZDd","row":"rOGDpD","spinnerRow":"d8y_kt","message":"R6xSOI","spin":"iUlZr0"};